import Sketch from "react-p5";
import Yurt from "./entities/yurt";
import { title } from "./entities/title";
import Stack from "./entities/stacks/stack";

let yurt = null;
let stack = null;
var width = 927;

const YurtPrintCanvas = ({ yurtTrait, wallTrait, pixels }) => {
  const handleWallChange = () => {
    return "false";
  };

  const handleYurtChange = () => {
    return "false";
  };

  const setup = (p5) => {
    var sketch = p5.createCanvas(width, 1200);
    sketch.parent("yurt-print-canvas");
  };

  const draw = (p5) => {
    p5.background(255);
    p5.angleMode(p5.DEGREES);

    p5.resizeCanvas(width, 1200);
    yurt = new Yurt(p5, yurtTrait, width, handleWallChange, wallTrait);
    stack = new Stack(p5, yurtTrait.stack, wallTrait, handleYurtChange);
    yurt.turn(p5, yurtTrait.placement);
    stack.render();
    yurt.render(p5, wallTrait, false);
    title(p5, yurtTrait, p5.width, pixels);
  };
  return (
    <div id="yurt-print-canvas" className="all-drawings">
      <Sketch setup={setup} draw={draw} />
    </div>
  );
};

export default YurtPrintCanvas;
